import Drawer from 'react-modern-drawer';
import { useEffect, useState } from "react";
import CueProductUpsert from "./cueProduct_upsert";
import metaDataServices from "../MetaDataServices";
import Production_listing from "./production_listing";

export default function CueUpsert(param: any) {

    console.log(param)

    let [cueOpen, SetcueOpen] = useState(false);
    let [isOpen, setIsOpen] = useState(param.cueOpen);
    let [cueUpsert, SetcuelUpsert] = useState<any>([]);
    let [productSelect, setProductSelect] = useState(false);
    let [cueUpsertData, SetcuelUpsertData] = useState<any>([]);
    let [showCueSuccessSaveMsg, setshowCueSuccessSaveMsg] = useState(false);

    const onChangecueUpsert = (e: any) => {
        console.log(e)
        cueOpen = false;
        SetcueOpen(cueOpen)
 
        SetcuelUpsertData({ ...cueUpsertData, programNumber: e?.programNumber??"", })
    }

    const onCloseDrawer = () => {
        param.onChange();
        isOpen = false;
        setIsOpen(isOpen)
    }

    useEffect(() => {
        cueUpsertData = param.cueUpsert
        SetcuelUpsertData(cueUpsertData)

    }, [param.cueUpsert])

    const resetCueUpsertForm = () => {
        cueUpsertData = [];
        SetcuelUpsertData(cueUpsertData)
    }

    const saveCueUpsertForm = () => {

        console.log(cueUpsertData)
        metaDataServices.cueSave(cueUpsertData).then((res:any) => {

            setshowCueSuccessSaveMsg(true)
            setTimeout(function () {
                setshowCueSuccessSaveMsg(false);
            }, 3000);
        })
    }

    const productSelection = (e: any) => {
        productSelect = false
        setProductSelect(productSelect)
    }

    const openCueEdit = (e: any) => {
        cueUpsert = e;
        SetcuelUpsert(e)

        cueOpen = true;
        SetcueOpen(cueOpen)
    }

    return (<>
        <Drawer open={isOpen}
            onClose={() => setIsOpen(false)}
            direction='right'
            className='react-drawer allowHscroll allowVscroll'
            size={800}>
            <div className="box noBorderRadius noBorder ws-6 pull-right">

                <div className="box-header  noBorderRadius bg-blue pLarge">  Add/Edit Cue </div>

                <div className="ws-12 pm ">

                    {showCueSuccessSaveMsg && <div className="alert alert-success">Cue saved successfully  </div>}

                    <div className="ws-12">
                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Master Cue</label>
                            <div className="label-entries">
                                <input className="ws-12" id="masterCue" name="masterCue" type="text" placeholder="Master Cue" value={cueUpsertData?.masterCue ?? ""} onChange={(e) => SetcuelUpsertData({ ...cueUpsertData, masterCue: e.target.value, })} />
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Cue Sheet Type</label>
                            <div className="label-entries">
                                <select id="cueSheetType" name="cueSheetType" value={cueUpsertData?.cueSheetType ?? ""} onChange={(e) => SetcuelUpsertData({ ...cueUpsertData, cueSheetType: e.target.value, })}>
                                    <option value="">Choose cue sheet type</option>
                                    {global?.cueSheetType?.map((values: any) => {
                                        return (<option className="width200" value={values?.cueSheetTypeDesc}>{values?.cueSheetTypeDesc}</option>)
                                    })}
                                </select>
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Program Number</label>
                            <div className="ws-12">
                                <input className="ws-9" name="programNumber" type="text" placeholder="Program Number" value={cueUpsertData?.programNumber ?? ""} disabled={true} />
                                <button className="icon-btn info pbl pull-right" onClick={() => openCueEdit({})}>Select</button>
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Production Id</label>
                            <div className="label-entries">
                                <input className="ws-9" name="productionId" type="text" placeholder="Production Id" value={cueUpsertData?.productionId ?? ""} disabled={true} />
                                <button className="icon-btn info pbl pull-right" onClick={() => setProductSelect(true)}> Select</button>
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Cue Theme</label>
                            <div className="label-entries">
                                <input className="ws-12" id="cueTheme" name="cueTheme" type="text" placeholder="Cue Theme" value={cueUpsertData?.cueTheme ?? ""} onChange={(e) => SetcuelUpsertData({ ...cueUpsertData, cueTheme: e.target.value, })} />
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Runtime</label>
                            <div className="label-entries">
                                <div className="input-group">
                                    <input className="w-50 text-right" name="runtimeDurationMinute" type="text" placeholder="Runtime Duration Minute" value={cueUpsertData?.runtimeDurationMinute ?? ""} onChange={(e) => SetcuelUpsertData({ ...cueUpsertData, runtimeDurationMinute: e.target.value, })} />
                                    <input className="w-50 text-right pull-right" name="runtimeDurationSecond" type="text" placeholder="Runtime Duration Second" value={cueUpsertData?.runtimeDurationSecond ?? ""} onChange={(e) => SetcuelUpsertData({ ...cueUpsertData, runtimeDurationSecond: e.target.value, })} />
                                </div>
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Cue Status</label>
                            <div className="label-entries">
                                <select id="cueStatus" name="songStatus" value={cueUpsertData?.productStatusName ?? ''} onChange={(e) => SetcuelUpsertData({ ...cueUpsertData, productStatusName: Number(e.target.value), })}>
                                    <option value="">Choose Status</option>
                                    {global?.statusProduct?.map((values: any) => {
                                        return (<option className="width200" value={values.productStatusUseID}>{values.ProductStatusShortCode}</option>)
                                    })}
                                </select>
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Extended Status</label>
                            <div className="label-entries">
                                <select id="extendedStatus" name="songStatusSplits" value={cueUpsertData?.productStatusExtName ?? ''} onChange={(e) => SetcuelUpsertData({ ...cueUpsertData, productStatusExtName: Number(e.target.value), })}>
                                    <option value="">Choose Status</option>
                                    {global?.statusProductExt?.map((values: any) => {
                                        return (<option className="width200" value={values.productStatusExtUseID}>{values.productStatusExtName}</option>)
                                    })}
                                </select>
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">DIM 1</label>
                            <div className="label-entries">
                                <input type="text" className="ws-12" placeholder="Enter DIM 1" name="catCoMedia" value={cueUpsertData?.analysisDiM1 ?? ""} onChange={(e) => SetcuelUpsertData({ ...cueUpsertData, analysisDiM1: e.target.value, })} />
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">DIM 2</label>
                            <div className="label-entries">
                                <input type="text" placeholder="Enter DIM 2" className="ws-12" name="analysisDiM2" value={cueUpsertData?.analysisDiM2 ?? ""} onChange={(e) => SetcuelUpsertData({ ...cueUpsertData, analysisDiM2: e.target.value, })} />
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">DIM 3</label>
                            <div className="label-entries">
                                <input type="text" placeholder="Enter DIM 3" className="ws-12" name="analysisDIM3" value={cueUpsertData?.analysisDiM3 ?? ""} onChange={(e) => SetcuelUpsertData({ ...cueUpsertData, analysisDiM3: e.target.value, })} />
                            </div>
                        </div>
                    </div>

                </div>

                <div className="ws-12 pm ">
                    <button type="button" className="icon-btn delete pull-right" onClick={() => onCloseDrawer()}>x Close</button>
                    <button type="button" className="icon-btn delete pull-right" onClick={() => resetCueUpsertForm()}>↻ Reset</button>
                    <button type="button" className="icon-btn edit pull-right" onClick={() => saveCueUpsertForm()}>✔ Save</button>
                </div>

                {
                    (() => {
                        if (productSelect) {
                            return <Production_listing onChange={productSelection} productSelect={productSelect} />
                        }

                        if (cueOpen) {
                            return <CueProductUpsert onChange={onChangecueUpsert} cueUpsert={cueUpsert} cueOpen={cueOpen} />
                        }

                    })()
                }
            </div>

        </Drawer>
    </>)
}